import { KeyValue } from 'app/developer-v3/components/KeyValueEditor';

import { TABS } from './constants';

export function disableKvps(kvps: KeyValue[]) {
  return kvps.map(kvp => ({ ...kvp, isDisabled: true }));
}

export function getTabs(disabledTabs: ('body' | 'options')[]) {
  return [
    {
      href: `#${TABS.PARAMS}`,
      id: TABS.PARAMS,
      text: 'URL Params',
    },
    {
      href: `#${TABS.HEADERS}`,
      id: TABS.HEADERS,
      text: 'HTTP Headers',
    },
    {
      href: `#${TABS.BODY}`,
      disabled: disabledTabs.includes('body'),
      id: TABS.BODY,
      text: 'Request Body',
    },
    {
      href: `#${TABS.OPTIONS}`,
      disabled: disabledTabs.includes('options'),
      id: TABS.OPTIONS,
      text: 'Options',
    },
  ];
}
